export const AVAILABLE_PERMISSIONS = [
  // User Management
  {
    id: "users",
    title: "Users",
    url: "/users",
    iconClass: "fas fa-users",
    category: "User Management"
  },
  {
    id: "sub-admin-management",
    title: "Sub Admin Management",
    url: "/sub-admin-management",
    iconClass: "fas fa-user-cog",
    category: "User Management"
  },

  // Booking & Finance
  {
    id: "booking-request",
    title: "Booking Request",
    url: "/booking-request-from-care-seeker",
    iconClass: "fas fa-shopping-bag",
    category: "Booking & Finance"
  },
  {
    id: "booking",
    title: "Booking",
    url: "/booking",
    iconClass: "fas fa-calendar-check",
    category: "Booking & Finance"
  },
  {
    id: "booking-cancel-request",
    title: "Booking Cancel Request",
    url: "/booking-cancel-request",
    iconClass: "fas fa-window-close",
    category: "Booking & Finance"
  },
  {
    id: "carer-availability",
    title: "Carer Availability",
    url: "/admin/carers/availability",
    iconClass: "fas fa-user-check",
    category: "Booking & Finance"
  },
  {
    id: "matchboard-requests",
    title: "Matchboard Requests",
    url: "/matchboard-requests",
    iconClass: "fas fa-route",
    category: "Booking & Finance"
  },
  {
    id: "end-trip",
    title: "Pay to Carer",
    url: "/end-trip",
    iconClass: "fas fa-hand-holding-usd",
    category: "Booking & Finance"
  },
  {
    id: "transaction",
    title: "Transactions",
    url: "/transaction",
    iconClass: "fas fa-dollar-sign",
    category: "Booking & Finance"
  },
  {
    id: "admin-transaction",
    title: "Admin Transactions",
    url: "/admin-transaction",
    iconClass: "fas fa-university",
    category: "Booking & Finance"
  },
  {
    id: "commission",
    title: "Commission",
    url: "/commission",
    iconClass: "fas fa-percentage",
    category: "Booking & Finance"
  },
  {
    id: "carer-withdrawals",
    title: "Carer Withdrawals",
    url: "/carer-withdrawals",
    iconClass: "fas fa-hand-holding-usd",
    category: "Booking & Finance"
  },
  {
    id: "withdraw",
    title: "Withdraw",
    url: "/withdraw",
    iconClass: "fas fa-money-bill-wave",
    category: "Booking & Finance"
  },
  {
    id: "package-benefits",
    title: "Package Benefits",
    url: "/package-benefits",
    iconClass: "fas fa-gift",
    category: "Booking & Finance"
  },
  {
    id: "pricing-simulator",
    title: "Pricing Simulator",
    url: "/pricing-simulator",
    iconClass: "fas fa-calculator",
    category: "Booking & Finance"
  },

  // Content & Settings
  {
    id: "content-management",
    title: "Content Management",
    url: "/content-management",
    iconClass: "fas fa-file-alt",
    category: "Content & Settings"
  },
  {
    id: "banner-management",
    title: "Banner Management",
    url: "/banner-management",
    iconClass: "fas fa-image",
    category: "Content & Settings"
  },
  {
    id: "custom-message",
    title: "Custom Messages",
    url: "/custom-message",
    iconClass: "fas fa-bullhorn",
    category: "Content & Settings"
  },
  {
    id: "faqs",
    title: "FAQs",
    url: "/faqs",
    iconClass: "fas fa-question-circle",
    category: "Content & Settings"
  },
  {
    id: "knowledge-base",
    title: "Knowledge Base",
    url: "/knowledge-base",
    iconClass: "fas fa-book",
    category: "Content & Settings"
  },
  {
    id: "notifications",
    title: "Notifications",
    url: "/notifications",
    iconClass: "fas fa-bell",
    category: "Content & Settings"
  },
  {
    id: "offer",
    title: "Offers & Promotions",
    url: "/offer",
    iconClass: "fas fa-tags",
    category: "Content & Settings"
  },
  {
    id: "language",
    title: "Languages",
    url: "/language",
    iconClass: "fas fa-language",
    category: "Content & Settings"
  },
  {
    id: "contact-forms",
    title: "Contact Forms",
    url: "/contact-forms",
    iconClass: "fas fa-envelope-open-text",
    category: "Content & Settings"
  },
  {
    id: "chat",
    title: "Chats",
    url: "/chat",
    iconClass: "fas fa-comments",
    category: "Content & Settings"
  },
  {
    id: "chat-support",
    title: "Chat Support",
    url: "/chat-support",
    iconClass: "fas fa-headset",
    category: "Content & Settings"
  },
  {
    id: "whatsapp-settings",
    title: "WhatsApp Settings",
    url: "/whatsapp-settings",
    iconClass: "fab fa-whatsapp",
    category: "Content & Settings"
  },
  {
    id: "support-knowledge-base",
    title: "Support Knowledge Base",
    url: "/support-knowledge-base",
    iconClass: "fas fa-book-reader",
    category: "Content & Settings"
  },

  // Documentation
  {
    id: "doc-architecture",
    title: "Architecture",
    url: "/documentation/architecture",
    iconClass: "fas fa-sitemap",
    category: "Documentation"
  },
  {
    id: "doc-booking-lifecycle",
    title: "Booking Lifecycle",
    url: "/documentation/booking-lifecycle",
    iconClass: "fas fa-project-diagram",
    category: "Documentation"
  },
  {
    id: "doc-data-flow",
    title: "Data Flow",
    url: "/documentation/data-flow",
    iconClass: "fas fa-exchange-alt",
    category: "Documentation"
  },
  {
    id: "doc-platform-overview",
    title: "Platform Overview",
    url: "/documentation/platform-overview",
    iconClass: "fas fa-globe",
    category: "Documentation"
  },
  {
    id: "doc-interactive-training",
    title: "Interactive Training",
    url: "/documentation/training",
    iconClass: "fas fa-chalkboard-teacher",
    category: "Documentation"
  },

  // System Tools
  {
    id: "report",
    title: "Reports",
    url: "/report",
    iconClass: "fas fa-chart-bar",
    category: "System Tools"
  },
  {
    id: "setting",
    title: "Settings",
    url: "/settings",
    iconClass: "fas fa-cog",
    category: "System Tools"
  },
  {
    id: "checklist-manager",
    title: "Checklist Manager",
    url: "/checklist-manager",
    iconClass: "fas fa-tasks",
    category: "System Tools"
  },
  {
    id: "app-config",
    title: "App Config",
    url: "/app-config",
    iconClass: "fas fa-mobile-alt",
    category: "System Tools"
  },
  {
    id: "otp-exceptions",
    title: "OTP Exceptions",
    url: "/otp-exceptions",
    iconClass: "fas fa-key",
    category: "System Tools"
  },
  {
    id: "api-logs",
    title: "API Logs",
    url: "/api-logs",
    iconClass: "fas fa-terminal",
    category: "System Tools"
  }
];
